module.exports = __webpack_public_path__ + "static/media/shirtLongSleeves.eda47ffe.jpg";